import { createReducer } from '@reduxjs/toolkit';

import { setIsLoading, setPostList, setTabsList } from './postActions.js';

const initialState = {
  postList: [],
  isLoading: false,
  tabsList: [],
};

const post = createReducer(initialState, (builder) => {
  builder
    .addCase(setPostList, (state, { payload: postList }) => ({ ...state, postList }))
    .addCase(setIsLoading, (state, { payload: isLoading }) => ({ ...state, isLoading }))
    .addCase(setTabsList, (state, { payload: tabsList }) => ({ ...state, tabsList }));
});

export default post;
